import React from "react";

import styles from "./AddressForm.module.scss";
import { Button } from "../../../common/components/button/Button";
import { GMapInput } from "../../../common/components/gMapInput/GMapInput";
import { FullAddress } from "../../../common/types/interfaces";
import { useAddressForm } from "./useAddressForm";

interface Props {
  initialData: FullAddress;
  saving?: boolean;
  isEditing?: boolean;
  onCancel: () => void;
  onSubmit: (data: FullAddress) => Promise<void> | void;
}

export const AddressForm: React.FC<Props> = ({
  initialData,
  saving,
  isEditing = false,
  onCancel,
  onSubmit,
}) => {
  const {
    data,
    setData,
    inputHandler,
    addressNotValid,
    formAction,
    closeForm,
    error,
  } = useAddressForm({ initialData, onSubmit, onCancel });

  return (
    <form
      className={styles.Form}
      onSubmit={(e) => {
        e.preventDefault();
        formAction();
      }}
    >
      <label className={styles.Field}>
        <span className={styles.Label}>Название</span>
        <input
          className={styles.Input}
          value={data.name}
          onChange={(e) => inputHandler(e.target.value, "name")}
          placeholder="Дом, работа…"
        />
      </label>

      <GMapInput
        fieldName="address"
        data={data}
        setData={setData}
        placeHolder="Введите адрес"
        required
      />

      <div className={styles.Row}>
        <label className={styles.Field}>
          <span className={styles.Label}>Подъезд</span>
          <input
            className={styles.Input}
            value={data.entrance || ""}
            onChange={(e) => inputHandler(e.target.value, "entrance")}
          />
        </label>
        <label className={styles.Field}>
          <span className={styles.Label}>Этаж</span>
          <input
            className={styles.Input}
            value={data.floor || ""}
            onChange={(e) => inputHandler(e.target.value, "floor")}
          />
        </label>
        <label className={styles.Field}>
          <span className={styles.Label}>Квартира</span>
          <input
            className={styles.Input}
            value={data.apartment || ""}
            onChange={(e) => inputHandler(e.target.value, "apartment")}
          />
        </label>
        <label className={styles.Field}>
          <span className={styles.Label}>Домофон</span>
          <input
            className={styles.Input}
            value={data.intercom || ""}
            onChange={(e) => inputHandler(e.target.value, "intercom")}
          />
        </label>
      </div>

      <label className={styles.Field}>
        <span className={styles.Label}>Комментарий</span>
        <textarea
          className={styles.Textarea}
          value={data.description || ""}
          onChange={(e) => inputHandler(e.target.value, "description")}
          rows={2}
        />
      </label>

      {!isEditing && (
        <label className={styles.Checkbox}>
          <input
            type="checkbox"
            checked={!!data.isGeneral}
            onChange={(e) =>
              setData((prev) => ({ ...prev, isGeneral: e.target.checked }))
            }
          />
          <span>Сделать основным</span>
        </label>
      )}

      {error && <div className={styles.Error}>{error}</div>}

      <div className={styles.Actions}>
        <Button title="Отмена" variant="ghost" onClick={closeForm} />
        <Button
          title="Сохранить"
          type="submit"
          loading={saving}
          disabled={addressNotValid}
        />
      </div>
    </form>
  );
};